module.exports = kolibriGlobal.coreVue.components.KCircularLoader;